// extracted by mini-css-extract-plugin
export default {"dash":"afzyX"};